export const environment = {
  production: true,
  development: false,
  test:false,
  // apiUrl: 'http://rollingexpenses.com:9002',
  apiUrl: 'http://rollingexpenses.com:9002',
  ANGULAR_ENV: '${MY_DOCKER_ENV}',
};
